import { ShieldCheck } from "lucide-react";

type VerifiedCompanyBadgeProps = {
  variant?: "light" | "overlay";
  compact?: boolean;
  iconOnly?: boolean;
  className?: string;
  onClick?: () => void;
};

const TOOLTIP_TEXT =
  "Identidade e dados cadastrais analisados " +
  "pela equipe do Fornecedor.net.";

export default function VerifiedCompanyBadge({
  variant = "light",
  compact = false,
  iconOnly = false,
  className = "",
  onClick,
}: VerifiedCompanyBadgeProps) {
  const variantClasses =
    variant === "overlay"
      ? (
          "border border-white/25 bg-white/15 " +
          "text-white backdrop-blur-md"
        )
      : (
          "border border-blue-200 bg-blue-50 " +
          "text-blue-700"
        );

  const Component = onClick ? "button" : "span";

  return (
    <Component
      {...(onClick
        ? {
            type: "button" as const,
            onClick,
          }
        : {})}
      title={TOOLTIP_TEXT}
      aria-label={
        "Empresa Verificada. " +
        TOOLTIP_TEXT
      }
      className={[
        "inline-flex w-fit items-center gap-1.5",
        "rounded-full font-bold",
        variantClasses,
        iconOnly
          ? "p-0"
          : compact
            ? "px-2 py-0.5 text-[10px] leading-4"
            : (
                "px-3 py-1.5 text-xs " +
                "uppercase tracking-[0.12em]"
              ),
        onClick
          ? "cursor-pointer transition hover:scale-[1.02]"
          : "",
        className,
      ].join(" ")}
    >
      <ShieldCheck
        size={iconOnly ? 24 : compact ? 13 : 16}
        aria-hidden="true"
      />

      {!iconOnly && "Empresa Verificada"}
    </Component>
  );
}
